/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Drastic_Tech_Extract_Start_File_LogInputs */

const en_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Extracting closed captioning from ${i?.name}-----`)
};

const fr_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Extraction des sous-titres depuis ${i?.name}-----`)
};

const de_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Extrahieren von Untertiteln aus ${i?.name}-----`)
};

const it_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Estrazione dei sottotitoli da ${i?.name}-----`)
};

const ru_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Извлечение субтитров из ${i?.name}-----`)
};

const es_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Extrayendo subtítulos de ${i?.name}-----`)
};

const zh_cn2_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----从${i?.name}提取隐藏式字幕-----`)
};

const ja_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----${i?.name} からクローズドキャプションを抽出しています-----`)
};

const hi_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----${i?.name} से क्लोज्ड कैप्शनिंग निकाली जा रही है-----`)
};

const pt_pt2_drastic_tech_extract_start_file_log = /** @type {(inputs: Drastic_Tech_Extract_Start_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Extraindo legendas ocultas de ${i?.name}-----`)
};

/**
* | output |
* | --- |
* | "-----Extracting closed captioning from {name}-----" |
*
* @param {Drastic_Tech_Extract_Start_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_start_file_log = /** @type {((inputs: Drastic_Tech_Extract_Start_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Start_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_extract_start_file_log(inputs)
	if (locale === "de") return de_drastic_tech_extract_start_file_log(inputs)
	if (locale === "it") return it_drastic_tech_extract_start_file_log(inputs)
	if (locale === "ru") return ru_drastic_tech_extract_start_file_log(inputs)
	if (locale === "es") return es_drastic_tech_extract_start_file_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_extract_start_file_log(inputs)
	if (locale === "ja") return ja_drastic_tech_extract_start_file_log(inputs)
	if (locale === "hi") return hi_drastic_tech_extract_start_file_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_extract_start_file_log(inputs)
	return en_drastic_tech_extract_start_file_log(inputs)
});